import { useEffect } from 'react';
import { useUIStore } from '@/stores';
import { useResponsiveLayout } from './useResponsiveLayout';

/**
 * Hook to sync sidebar collapse state with artifact viewer
 * - 🔥 Only collapses sidebar on MOBILE when artifact viewer opens
 * - On desktop (PC), sidebar stays as-is when artifact viewer opens
 * - Restores previous sidebar state when artifact viewer closes (mobile only)
 */
export function useArtifactSidebarSync() {
  const { artifactViewer, isSidebarCollapsed, sidebarCollapsedBeforeArtifact } =
    useUIStore();
  const { isMobile } = useResponsiveLayout();

  useEffect(() => {
    // 🔥 PC 端不自动收起侧边栏
    if (!isMobile) return;

    if (artifactViewer) {
      // Artifact viewer is opening (mobile only)
      if (sidebarCollapsedBeforeArtifact === null) {
        useUIStore.setState({
          sidebarCollapsedBeforeArtifact: isSidebarCollapsed,
          isSidebarCollapsed: true,
        });
      }
    } else {
      // Artifact viewer is closing (mobile only)
      if (sidebarCollapsedBeforeArtifact !== null) {
        useUIStore.setState({
          isSidebarCollapsed: sidebarCollapsedBeforeArtifact,
          sidebarCollapsedBeforeArtifact: null,
        });
      }
    }
  }, [
    artifactViewer,
    isSidebarCollapsed,
    sidebarCollapsedBeforeArtifact,
    isMobile,
  ]);
}
